import { difference } from 'lodash'
export default (arrayA = [], arrayB = []) => !difference(arrayA, arrayB).length
